/* 🤖 this file was generated by svg-to-ts */
export const siriusClockDuotone: {
  name: 'clock_duotone';
  data: string;
} = {
  name: 'clock_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" fill="currentColor"/><path d="M12 2.25A9.75 9.75 0 1 0 21.75 12 9.769 9.769 0 0 0 12 2.25Zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25Z" fill="currentColor"/><path d="M17.25 11.25h-4.5v-4.5a.75.75 0 1 0-1.5 0V12a.75.75 0 0 0 .75.75h5.25a.75.75 0 1 0 0-1.5Z" fill="currentColor"/></svg>`
};
